export enum InputFileTypeEnum {
    Button = "Button",
    Card = "Card",
    V4 = "V4"
}